import $ from 'jquery'

function init() {
    if (!$('body').hasClass('plan_builder')) {
        return
    }

    setUpEventListeners()
    setUpPreviewPoller()
}

function setUpEventListeners() {
    $('.content-block .rates .coverage select').on('change', events.onContentBlockRatesCoverageSelectChange)
}

function setUpPreviewPoller() {
    if (!$('body').hasClass('preview')) {
        return
    }

    setInterval(planPreviewPoll, 5000)
}

function planPreviewPoll() {
    $.getJSON(
        '/plan_builder/check_preview_refresh',
        response => {
            if (response.should_refresh) {
                window.location.reload()
            }
        }
    )
}

const events = {
    onContentBlockRatesCoverageSelectChange() {
        const select = $(this),
            coverage_area_id = parseInt( select.val() ),
            rates_block = select.closest('.rates'),
            rates_rows = rates_block.find('.rates--rows'),
            rate_data = rates_rows.data('rate-data'),
            data_keys = [ 'employee', 'employee_spouse', 'employee_children', 'family' ]

        $(rate_data).each((index, datum) => {
            if (datum.coverage_area_id == coverage_area_id) {
                for (let i=0, key; i<data_keys.length; i++) {
                    key = data_keys[i]

                    rates_rows.find('.' + key).html( datum[key] )
                }
            }
        })
    }
}

export default { init }